<aw-add-testers-to-testbed [data]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-add-testers-to-testbed>